var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHyprFlows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8046_6357)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8046_6357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8046_6357)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8046_6357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8046_6357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6499 1.87061H4.1499V4.37061H6.6499V1.87061Z",
    fill: "url(#paint0_linear_8046_6357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7H0V9.5H2.5V7Z",
    fill: "url(#paint1_linear_8046_6357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7H4V9.5H6.5V7Z",
    fill: "url(#paint2_linear_8046_6357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7H8V9.5H10.5V7Z",
    fill: "url(#paint3_linear_8046_6357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3009 5.99497C10.379 6.06323 10.4125 6.17675 10.4038 6.34215L10.6137 6.35307C10.626 6.1192 10.5687 5.95044 10.4392 5.83702C10.1278 5.56429 9.4743 5.68706 8.4849 5.87252C7.6607 6.02721 6.64498 6.21403 5.4922 6.23713V4.28613H5.28217V6.23713C4.12929 6.21403 3.11378 6.02721 2.28961 5.87252C1.30045 5.68695 0.646719 5.56429 0.335239 5.83702C0.205649 5.95044 0.148519 6.11931 0.160809 6.35307L0.370629 6.34215C0.361919 6.17685 0.39552 6.06333 0.47355 5.99497C0.70816 5.78966 1.38888 5.91736 2.25086 6.07908C3.07965 6.2344 4.09957 6.42322 5.26358 6.4478V6.45263C5.30548 6.45263 5.34571 6.45053 5.38719 6.45021C5.42877 6.45063 5.469 6.45263 5.5109 6.45263V6.4478C6.67491 6.42333 7.69493 6.23451 8.5236 6.07908C9.3855 5.91736 10.0663 5.78966 10.3009 5.99497Z",
    fill: "url(#paint4_linear_8046_6357)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8046_6357",
    x1: 5.3999,
    y1: 1.87061,
    x2: 5.3999,
    y2: 4.37061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8046_6357",
    x1: 1.25,
    y1: 7,
    x2: 1.25,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8046_6357",
    x1: 5.25,
    y1: 7,
    x2: 5.25,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8046_6357",
    x1: 9.25,
    y1: 7,
    x2: 9.25,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8046_6357",
    x1: 5.38725,
    y1: 4.28613,
    x2: 5.38725,
    y2: 6.45263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8046_6357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHyprFlows);
export default __webpack_public_path__ + "static/media/Menu-HyprFlows.c43a13803098d5b4987489141250a22f.svg";
export { ForwardRef as ReactComponent };